import { sva } from '@onbeam/business-styled-system/css';

export const popover = sva({
  className: 'popover',
  slots: ['content', 'card', 'hidden'],
  base: {
    content: {
      zIndex: 50,
      p: '1',
      rounded: 'md',
      animationName: 'fadeIn',
      animationDuration: 'fast',

      _closed: {
        animationName: 'fadeOut',
      },
    },
    hidden: {
      srOnly: true,
    },
  },
});
